import { render, staticRenderFns } from "./IndividualApplicants.vue?vue&type=template&id=35f02dd3"
import script from "./IndividualApplicants.vue?vue&type=script&lang=js"
export * from "./IndividualApplicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports